import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectAppNumber } from '../feature/app.Slice';
import {
  getPageTitleByAppNumber,
  getFaviconByAppNumber,
  isValidAppNumber,
  resolveAppNumberFromEnvironment
} from '../config/appsConfig';

/**
 * DocumentHead met à jour dynamiquement le titre de l'onglet et le favicon
 * en fonction de l'application (Klesia Pro, Klesia Mut, Carcept, GHR).
 */
const DocumentHead = () => {
  const appNumber = useSelector(selectAppNumber);

  useEffect(() => {
    const currentAppNumber =
      appNumber ??
      resolveAppNumberFromEnvironment({
        hostname: window.location.hostname,
        port: window.location.port,
        search: window.location.search
      });

    const title = isValidAppNumber(currentAppNumber)
      ? getPageTitleByAppNumber(currentAppNumber)
      : 'Mes bons plans KLESIA';
    document.title = title;

    const faviconHref = isValidAppNumber(currentAppNumber)
      ? getFaviconByAppNumber(currentAppNumber)
      : '/favicon.ico';

    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = faviconHref;
    link.type = faviconHref.endsWith('.png') ? 'image/png' : 'image/x-icon';
  }, [appNumber]);

  return null;
};

export default DocumentHead;
